import Stickyfill from 'stickyfilljs';
/**
 * Get all sticky elements from page
 *
 * @type {NodeListOf<Element>}
 */
const stickyElements = document.querySelectorAll('[data-sticky]');
/**
 * Add JS polyfill for sticky job
 */
Stickyfill.add(stickyElements);
